import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MentorsFiltersState {
  search: string;
}

const initialState: MentorsFiltersState = {
  search: "",
};

const mentorsFiltersSlice = createSlice({
  name: "mentorsFilters",
  initialState,
  reducers: {
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    resetSearch(state) {
      state.search = "";
    },
  },
});

export const { setSearch, resetSearch } = mentorsFiltersSlice.actions;
export default mentorsFiltersSlice.reducer;
